import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=21b4177b&"
import script from "./ShiftReport.vue?vue&type=script&lang=js&"
export * from "./ShiftReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b4177b')) {
      api.createRecord('21b4177b', component.options)
    } else {
      api.reload('21b4177b', component.options)
    }
    module.hot.accept("./ShiftReport.vue?vue&type=template&id=21b4177b&", function () {
      api.rerender('21b4177b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduling/reports/ShiftReport.vue"
export default component.exports